type ThumbnailSize = 'h400';

export const thumbnailUri = (imageUri : string, size : ThumbnailSize) => {
    return imageUri.replace(/\/([^/]+)$/, `/${size}/$1`);
};
